<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { axiosGetPost } from '@router/axiosGetPost'
import AddSurchargeList from '@components/contract/add-surcharge-list'
import EditSurchargeList from '@components/contract/edit-surcharge-list'

export default {
  page: {
    title: 'Surchargers',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, AddSurchargeList, EditSurchargeList },
  data() {
    return {
      title: 'Surchargers',
      items: [
        {
          text: 'Barracuda',
          href: '/',
        },
        {
          text: 'Management',
          active: false,
        },
        {
          text: 'Surchargers',
          active: false,
        },
      ],
      typeTable: 'harbors',
      tableData: [{ data: 'ok' }],
      tableDataComplet: [{ data: 'ok' }],
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'id',
      sortDesc: false,
      fields: [],
      fieldList: [{ key: 'data' }],
      excludeFields: [],
      loadingTable: true,
      modalComponent: 'AddSurchargeList',
      modalTitle: 'Add Surcharger',
      modalError: null,
      modalErrorShow: false,
      showModal: false,
      loadingData: false,
      rowId: null,
      isGeneral: false,
      checkBox: true,
    }
  },
  computed: {
    rows() {
      return this.tableData.length
    },
  },
  created() {
    this.fetchData()
    this.isGeneral = true
    this.totalRows = this.tableData.length
  },
  methods: {
    clickClasification(){
         this.isGeneral = !this.isGeneral
         this.clasificateGenaral()
    },
    clasificateGenaral() {
      this.loadingTable = true
   
      if (this.isGeneral ) {
        this.tableData = this.tableDataComplet.filter(function (item) {
          return item['is_general'] == 1
        })
      } else {
        this.tableData = this.tableDataComplet
      }
      this.loadingTable = false
    },
    fetchData() {
      this.loadingTable = true
      this.time = 0

      axiosGetPost('get', '/cargofive/surchargers/list').then((response) => {
        console.log(response)
        const data = response
        this.tableDataComplet = data.data[0]
        this.clasificateGenaral()
        this.fieldList = data.data[1]
        this.updateTableFields('SELECT')
        this.loadingTable = false
        return data
      })
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
    },
    customFilterTable(row, filter) {
      var valuesRow = Object.values(row)
      //console.log(values)
      let filtersSp = filter.split(' ')
      var flag = false
      const filtersFined = []
      filtersSp.forEach((filterVal) => {
        valuesRow.filter((valRow) => {
          var valRowLC = String(valRow).toLowerCase()
          var filterValLC = String(filterVal).toLowerCase()
          if (valRowLC.includes(filterValLC)) {
            if (!filtersFined.includes(filterVal)) filtersFined.push(filterVal)
          }
        })
      })

      return filtersFined.length === filtersSp.length
    },
    updateTableFields(action = 'SELECT') {
      if (action === 'SELECT') {
        axiosGetPost('post', 'settingU/', {
          modules: [this.typeTable + '_mg'],
        }).then((data) => {
          if (data.success === true) {
            this.excludeFields = data.data[this.typeTable + '_mg']
            this.orderFields()
          } else {
            this.$toastr.e('Error Load Exclude column Select' + data.error)
          }
          return data
        })
      } else if (action === 'UPDATE') {
        this.orderFields()
        axiosGetPost('put', 'settingU/', {
          modules: [{ name: this.typeTable + '_mg', data: this.excludeFields }],
        }).then((data) => {
          if (data.success !== true) {
            this.$toastr.e('Error Load Exclude column Update' + data.error)
          }
          return data
        })
      }
    },
    orderFields() {
      this.fields = []
      for (var [key, value] of Object.entries(this.fieldList)) {
        if (!(this.excludeFields.indexOf(value.key) > -1)) {
          this.fields.push(this.fieldList[key])
        }
      }
    },
    addNew() {
      this.showModal = true
      this.modalComponent = 'AddSurchargeList'
      this.modalTitle = 'Add Surcharger'
      this.modalError = null
      this.modalErrorShow = false
    },
    saveModal() {
      this.showModal = false
    },
    deleteRow(id) {
      this.$swal({
        title:
          'Are you sure you want to delete this harbor with ID ' +
          id +
          '? This action is irreversible.',
        showCancelButton: true,
        confirmButtonColor: 'brown',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.value) {
          this.loadingData = true
          axiosGetPost('post', '/cargofive/surchargers/list', {
            id: id,
          }).then((response) => {
            if (response.success) {
              this.$toastr.s('Sucess. Surchargers Deleted')
              this.fetchData()
            } else {
              this.$toastr.e("Attention. You can't delete this row! ")
            }
            this.loadingData = false
            this.saveModal()
            return response
          })
        } else {
          this.$swal('Cancelled')
        }
      })
    },
    editRow(id) {
      this.rowId = id
      this.showModal = true
      this.modalComponent = 'EditSurchargeList'
      this.modalTitle = 'Edit Surcharge'
      this.modalError = null
      this.modalErrorShow = false
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-md-2">
              <div class="col-sm-3 col-md-8 text-md-left">
                <h4 class="header-title mt-0 mb-1">Surcharge List</h4>
              </div>
              <div class="col-sm-4 col-md-4 text-md-right">
                <b-button
                  class="btn btn-primary col-md-5"
                  variant="primary"
                  @click="addNew"
                  >Add <i class="uil uil-plus"></i>
                </b-button>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-12">
                <div class="d-flex mb-md-2">
                  <!-- Inicio Table */******************************************************* */ -->
                  <div class="mr-auto">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Inicio Ocultar columnsas /********************/**************-->
                  <div> <b-form-checkbox v-model="checkBox" @change="clickClasification" name="check-button" switch>
                          Company: General &nbsp;
                        </b-form-checkbox>
                  </div>
                  <div>
                    <b-dropdown
                      class="d-inline"
                      variant="link"
                      toggle-class="font-weight-bold p-0 align-middle"
                    >
                      <template v-slot:button-content>
                        Hide Columns
                        <i
                          class="uil uil-eye-slash font-size-16 align-middle"
                        ></i
                        ><i
                          class="uil uil-angle-down font-size-16 align-middle"
                        ></i>
                      </template>
                      <div v-for="(field, index) of fieldList" :key="index">
                        <div v-if="field.checkBox" class="dropdown-item">
                          <div class="col-lg-6 mb-2 mb-lg-0">
                            <div
                              :for="`field-${index + '-' + typeTable + '_mg'}`"
                              class="custom-control custom-checkbox"
                            >
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                :id="`field-${index + '-' + typeTable + '_mg'}`"
                                :value="field.key"
                                v-model="excludeFields"
                                @change="updateTableFields('UPDATE')"
                              />
                              <label
                                class="custom-control-label"
                                :for="`field-${
                                  index + '-' + typeTable + '_mg'
                                }`"
                                >{{ field.label }}</label
                              >
                            </div>
                            <!-- end checkbox -->
                          </div>
                        </div>
                      </div>
                    </b-dropdown>
                  </div>
                  <!-- Fin Ocultar columnsas /********************/**************-->
                  <!-- Search -->
                  <div>
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ml-2"
                      ></b-form-input>
                    </label>
                  </div>

                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table
                    striped
                    hover
                    :items="tableData"
                    :fields="fields"
                    responsive="sm"
                    :busy="loadingTable"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :filter-function="customFilterTable"
                    @filtered="onFiltered"
                  >
                    <template v-slot:table-busy>
                      <div
                        class="row align-items-center justify-content-center"
                        style="height: 150px"
                      >
                        <div class="col-12 col-md-8 text-center">
                          <b-spinner
                            label="Loading..."
                            variant="primary"
                            class="ml-3"
                          ></b-spinner>
                        </div>
                      </div>
                    </template>
                    <template v-slot:cell(actions)="row">
                      <div>
                        <b-dropdown
                          variant="success"
                          dropleft
                          class="ml-1 btn-sm"
                        >
                          <template slot="button-content">
                            <i
                              class="uil uil-angle-double-left"
                              style="color: #278c27"
                            ></i>
                            <i>Options</i>
                          </template>
                          <b-dropdown-item
                            href="#"
                            style="color: ##0a399a"
                            @click="editRow(row.item.id)"
                          >
                            <span style="color: rgb(1 38 113)"
                              ><i class="uil uil-edit"></i>&nbsp; &nbsp;
                              Edit</span
                            >
                          </b-dropdown-item>
                          <b-dropdown-item
                            href="#"
                            style="color: ##0a399a"
                            @click="deleteRow(row.item.id)"
                          >
                            <span style="color: rgb(1 38 113)"
                              ><i class="uil uil-trash"></i>&nbsp; &nbsp; Delete
                            </span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>
                    </template>
                  </b-table>
                </div>
                <div class="row">
                  <div class="col">
                    <strong
                      >Filtered {{ totalRows }} of {{ rows }} entries</strong
                    >
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-lefts
                      "
                    >
                      <span>
                        <!--<i>Total Rows: {{ rows }}</i>-->
                      </span>
                    </div>
                  </div>
                  <div class="col">
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-right
                      "
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>

                <!-- Fin Table */******************************************************* */ -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal
        id="modal-lg"
        ref="requestFcl"
        v-model="showModal"
        size="lg"
        :title="modalTitle"
        title-class="font-18"
      >
        <div
          v-if="loadingData"
          class="row align-items-center justify-content-center"
          style="height: 300px"
        >
          <div class="col-12 col-md-8 text-center">
            <b-spinner
              label="Loading..."
              variant="primary"
              class="ml-3"
            ></b-spinner>
          </div>
        </div>

        <div v-else-if="modalErrorShow === true">
          <div
            class="row align-items-center justify-content-center"
            style="height: 300px"
          >
            <div class="col-12 col-md-8 text-center">
              <feather type="frown" class="icon-xxl icon-dual-info"></feather>
              <h6 class="text-muted">{{ modalError }}</h6>
            </div>
          </div>
        </div>

        <AddSurchargeList
          v-if="modalComponent === 'AddSurchargeList'"
          @update_view="fetchData"
          @close_modal="saveModal"
        />

        <EditSurchargeList
          v-if="modalComponent === 'EditSurchargeList'"
          :row-id="rowId"
          @update_view="fetchData"
          @close_modal="saveModal"
        />

        <template v-slot:modal-footer>
          <b-button variant="light" @click="$refs.requestFcl.hide"
            >Close</b-button
          >
          <b-button
            v-if="
              loadingData === false &&
              modalErrorShow === false &&
              ['AddSurchargeList', 'EditSurchargeList'].includes(modalComponent) !== true

            "
            variant="primary"
            @click="saveModal"
          >
            OK
          </b-button>
        </template>
      </b-modal>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style>
.table-responsive-list-menu {
  overflow-x: visible !important;
  overflow-y: visible !important;
}

.badge-soft-warning {
  color: #c39411 !important;
  background-color: rgba(255, 190, 11, 0.2);
}

.badge-soft-success {
  color: #299a70 !important;
  background-color: rgba(67, 211, 158, 0.2);
}

.badge-tier-1 {
  color: #ffffff !important;
  background-color: #1f56d6;
}

.badge-tier-2 {
  color: #ffffff !important;
  background-color: #1f93d6;
}

.badge-tier-3 {
  color: #ffffff !important;
  background-color: #1dbfd7;
}

.btn-success:hover {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.btn-success {
  color: #0014a2;
  background-color: #ffffff;
  border-color: #031b4e;
}

.show .btn-success.dropdown-toggle {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.text {
  font-family: helvetica;
  font-weight: bold;
  color: #71d90b;
}
</style>